import { Text } from "ui-kit/components-branded/index"
import { NonImgAvatar } from "components"
import { getParsePhoneNumber } from "utils/phone-number"

interface Props {
    name?: string
    phone: string
    email: string
}

export function ContactsClient({ name, phone, email }: Props) {
    const formatPhone = getParsePhoneNumber(phone)

    return (
        <>
            {name && (
                <Text className="booking-contacts-client__name mgb-4">
                    <NonImgAvatar size="XS" className="mr-2">
                        {name}
                    </NonImgAvatar>
                    {name}
                </Text>
            )}
            <Text className="booking-contacts-client__contacts">
                {formatPhone && (
                    <div className="booking-contacts-client__telephone">{formatPhone}</div>
                )}
                {formatPhone && <div className="booking-contacts-client__dots" />}
                <div className="booking-contacts-client__email">{email}</div>
            </Text>
        </>
    )
}
